import { createApp } from 'vue/dist/vue.esm-bundler';
import CalendarConfigModel from "../Models/CalendarConfigModel.js";
import Calendar from "../Components/Calendar.vue";
import DetailCalendarController from "../Controllers/DetailCalendarController.js";
import * as Vue from "vue";
import {uuid} from "../helpers.js";
import {watch} from "vue";
export default class CalendarServiceProvider
{
    /**
     * @type {Object.<string, Vue>}
     */
    static _calendars = {};
    /**
     * @param calendarConfigModel {CalendarConfigModel}
     */
    constructor(calendarConfigModel)
    {
        this.calendarConfigModel = calendarConfigModel;

        const { Calendar, DetailCalendar } = CalendarConfigModel.supportedTypes;
        if (this.calendarConfigModel.type === Calendar) {
            this.bootCalendars();
        }
        else if (this.calendarConfigModel.type === DetailCalendar) {
            this.bootDetailedCalendars();
        }
    }

    /**
     * Boots any standard calendars
     */
    bootCalendars()
    {
        this.calendarConfigModel.elements.forEach(element => {
            const app = createApp(Calendar, {
                calendarConfigModel: this.calendarConfigModel,
                uuid: uuid()
            }).mount(element);
            this.addBootedCalendar(element, app);
        });
    }
    /**
     * @param calendarName {string}
     * @return CalendarConfigModel|null
     */
    static getConfig(calendarName)
    {
        const app = CalendarServiceProvider._calendars[calendarName];
        return app ? app.calendarConfigModel : null;
    }
    /**
     * @param calendarName {string}
     * @param calendarConfigModel {CalendarConfigModel}
     */
    static refresh(calendarName, calendarConfigModel)
    {
        const app = CalendarServiceProvider._calendars[calendarName];
        if (! app) {
            return;
        }
        const { DetailCalendar } = app.calendarConfigModel.supportedTypes;
        if (app.calendarConfigModel.type == DetailCalendar) {
            app.calendarConfigModel = calendarConfigModel;
            app.refresh();
        }
    }
    /**
     * @param element {HTMLElement}
     * @param app {Vue}
     */
    addBootedCalendar(element, app)
    {
        const name = this.getCalendarName(element);
        if (name) {
            CalendarServiceProvider._calendars[name] = app;
        }
    }
    /**
     * @param rootElement {HTMLElement}
     * @return string|null
     */
    getCalendarName(rootElement)
    {
        return rootElement.getAttribute('calendar-name') ?? null;
    }
    /**
     * If there is more control on what's displayed when dates are selected
     * we can call the DetailCalendar
     */
    bootDetailedCalendars()
    {
        const calendarConfigModel = this.calendarConfigModel;
        for (let element of calendarConfigModel.elements) {
            const app = createApp({
                name: 'DetailCalendar',
                components: {
                    'calendar': Calendar
                },
                setup() {
                    const controller = new DetailCalendarController(element, calendarConfigModel);
                    return controller.getViewData();
                }
            }).mount(element);
            this.addBootedCalendar(element, app);
        }
    }
}
